import { render, staticRenderFns } from "./base-input.vue?vue&type=template&id=404a521c&scoped=true"
import script from "./base-input.vue?vue&type=script&lang=js"
export * from "./base-input.vue?vue&type=script&lang=js"
import style0 from "./base-input.vue?vue&type=style&index=0&id=404a521c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a521c",
  null
  
)

export default component.exports